/**
 * WordPress dependencies
 */
export * from '@wordpress/blocks';
